import React, { useEffect, useRef } from 'react';

const MapboxComponent = () => {
  const mapContainer = useRef(null);
  const map = useRef(null);

  const position = {
    lat: 1.354787251077238,
    lng: 103.87776630378643,
  };

  const mapStyles = {
    height: "500px",
    width: "100%",
  };

  useEffect(() => {
    const script = document.createElement('script');
    script.src = 'https://api.mapbox.com/mapbox-gl-js/v2.9.1/mapbox-gl.js';
    script.async = true;
    document.body.appendChild(script);

    script.onload = () => {
      if (map.current) return; // initialize map only once
      
      mapboxgl.accessToken = 'pk.eyJ1IjoiZWRtdW5kZ2FpciIsImEiOiJjbGM1bmtndnkwemp4M29wZ2o3M2U1dnFwIn0.QclkggD-SL2vGm0LgeaeKg';
      map.current = new mapboxgl.Map({
        container: mapContainer.current,
        style: 'mapbox://styles/mapbox/streets-v11',
        center: [position.lng, position.lat], // Note: Mapbox uses [lng, lat] order
        zoom: 14 // Increased zoom for better view of the specific location
      });

      // Add a marker at the specified position
      new mapboxgl.Marker()
        .setLngLat([position.lng, position.lat])
        .addTo(map.current);
    };

    return () => {
      document.body.removeChild(script);
      if (map.current) {
        map.current.remove();
      }
    };
  }, []);

  return (
    <div className="container">
      <link href="https://api.mapbox.com/mapbox-gl-js/v2.9.1/mapbox-gl.css" rel="stylesheet" />
      <div ref={mapContainer} style={mapStyles} />
    </div>
  );
};

export default MapboxComponent;